<div class="box">
    <p class="header mx-4">{{propertyCount}} Results</p>
    <div class="custom-filter-styles">
        <app-filter [filterObject]="filterObject" (searchEvent)="searchProperty($event)"
            (toggleFavouriteEvent)="handleToggleFavourite($event)"></app-filter>
    </div>
    <div class="propertycard">
        <div [ngClass]="{'gap-logged-out': !checkLoginStatus, 'gap-logged-in': checkLoginStatus}" class="property-card"
            infiniteScroll
            [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300" [scrollWindow]="false" (scrolled)="onScroll()">
            <div *ngFor="let value of propertyList" style="display: flex; justify-content: center; width: 100%;">
                <div class="card img-cards"
                    [ngClass]="{'img-card-small': !checkLoginStatus, 'img-card-medium': checkLoginStatus}"
                    (click)="openProjectView(value)" style="cursor: pointer;">
                    <fa-icon [icon]="faHeart" class="favorite-icon" [ngClass]="{'favorite': value.favProperty}"
                        (click)="toggleFavorite($event, value)" *ngIf="!isAdmin" [ngbTooltip]="'Save'">
                    </fa-icon>
                    <ngb-carousel #carousel [interval]="5000" [showNavigationIndicators]="false"
                        [showNavigationArrows]="value.propertyDocs?.length > 1"
                        class="carousel slide overflow-hidden rounded-top">
                        <ng-template ngbSlide *ngFor="let item of value.galleryPics; index as imageIndex">
                            <div class="carousel-img-wrapper overflow-hidden rounded-top">
                                <img [src]="item.objectUrl" alt="Property Image"
                                    class="img-fluid w-100 h-100 object-fit-cover rounded-top" />
                            </div>
                        </ng-template>
                    </ngb-carousel>

                    <div class="card-body">
                        <p class="title" title="{{value.projectName}}">{{value.projectName}}</p>
                        <div class="edit-button" *ngIf="isAdmin">
                            <app-common-button buttonClass="smallbuttoncancel" buttonLabel="Edit"
                                (click)="onPropertyEditClicked(value._id)"></app-common-button>
                        </div>
                        <p class="size"> Size: <span class="size">{{value.minimumSize.value }} </span>
                            <span class="size prop_size"> {{ value?.minimumSize.unitType}}</span>
                            <span *ngIf="value.units?.length > 0"> Onwards</span>
                        </p>
                        <p class="price">
                            <span>{{ value?.totalPrice }} </span>
                        </p>
                        <p class="location">Location: <span class="location"
                                ngbTooltip="{{value.address.locality}},{{value.address.city}}">{{value.address.locality}},
                                {{value.address.city}}</span></p>
                        <div class="buttons" (click)=" $event.stopPropagation()">

                            <div class="enquiry" *ngIf="!isAdmin">
                                <app-common-button buttonClass="view-enquiry" buttonLabel="Enquire Now"
                                    (clickEvent)="openEnquiry(value)"></app-common-button>
                            </div>
                            <div *ngIf="isAdmin && checkLoginStatus">
                                <app-common-button buttonClass="view-enquiry"
                                    buttonLabel="Enquiry List ({{value.enquiresCount || 0}})"
                                    (clickEvent)="openEnquiryList(value)"></app-common-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="verifyLoader" class="loader">
              <app-common-icon [loadingIcon]="verifyLoader"></app-common-icon>
            </div>

            <div *ngIf="favproperty && !verifyLoader && propertyList.length === 0" class="no-favorites-message">
              No saved properties.
            </div>
            <div *ngIf="!favproperty && propertyList.length === 0 && !verifyLoader" class="no-favorites-message">
              No properties found.
            </div>


        </div>
    </div>
</div>
<app-enquiry-popup [propertyId]="selectedPropertyId" [isEnquiry]="isEnquiry"
    (closeModal)="closeEnquiry()"></app-enquiry-popup>
<div *ngIf="isEnquiryList">
    <app-enquiry-list [isEnquiryList]="isEnquiryList" [propertyId]="selectedPropertyId"
        (closeModal)="closeEnquiryList()"></app-enquiry-list>
</div>
<div *ngIf="!checkLoginStatus">
    <app-login-popup [isVisible]="isLoginModalVisible" (closeModal)="closeProjectModal()"></app-login-popup>
</div>
